<template>
  <div class="tenant_option_info_area" id="tenant_option_info">
    <div class="edit_area_half">
      <valueLabelSection
        :titleLabel="passwordEnableFlagLabel"
        :valueLabel="passwordEnableFlag"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="autoLogoutEnableFlagLabel"
        :valueLabel="autoLogoutEnableFlag"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="autoLogoutSecondLabel"
        :valueLabel="autoLogoutSecond"
      ></valueLabelSection>
      <valueLabelSection
        :titleLabel="ratingQuarityEnableFlagLabel"
        :valueLabel="ratingQuarityEnableFlag"
      ></valueLabelSection>
      <checkBoxBindSection
        :titleLabel="pushNotificationEnableFlagLabel"
        :nameValue="pushNotificationEnableFlag"
        :checked="corporation.pushNotificationEnableFlag"
      ></checkBoxBindSection>
      <checkBoxBindSection
        :titleLabel="spEnableFlagLabel"
        :nameValue="spEnableFlag"
        :checked="corporation.spEnableFlag"
      ></checkBoxBindSection>
      <checkBoxBindSection
        :titleLabel="contactsEnableFlagLabel"
        :nameValue="contactsEnableFlag"
        :checked="corporation.contactsEnableFlag"
      ></checkBoxBindSection>
      <textAreaBindSection
        :titleLabel="remarksLabel"
        :bindValue="corporation.remarks"
        @inputUpdate="inputUpdate('remarks')"
      ></textAreaBindSection>
    </div>
    <div class="edit_area_half">
      <callAppCheckboxListSection
        :titleLabel="linkedApplication"
        :callAppList="callAppList"
      ></callAppCheckboxListSection>
    </div>
  </div>
</template>

<script>
import inputSection from './inputSection.vue'
import checkBoxBindSection from './checkBoxBindSection.vue'
import textAreaBindSection from './textAreaBindSection.vue'
import dropDownSection from './dropDownSection.vue'
import valueLabelSection from './valueLabelSection.vue'
import callAppCheckboxListSection from './callAppCheckboxListSection.vue'

export default {
  data() {
    return {
      passwordEnableFlagLabel: 'アプリパスワードの使用有無',
      autoLogoutEnableFlagLabel: 'アプリ自動ログアウトの使用有無',
      autoLogoutSecondLabel: '自動ログアウト時間',
      ratingQuarityEnableFlagLabel: '評価管理機能の使用有無',
      pushNotificationEnableFlagLabel: 'push通知機能の使用有無',
      spEnableFlagLabel: 'サイレントpush通知機能の使用有無',
      contactsEnableFlagLabel: '標準電話帳連携機能の使用有無',
      remarksLabel: '備考',
      passwordLabel: '管理者パスワード',
      initialValue: 3600,
      pushNotificationEnableFlag: 'pushNotification_enable',
      spEnableFlag: 'silentPush_enable',
      contactsEnableFlag: 'contacts_enable',
      linkedApplication: '連携アプリ'
    }
  },
  components: {
    inputSection,
    checkBoxBindSection,
    textAreaBindSection,
    dropDownSection,
    valueLabelSection,
    callAppCheckboxListSection
  },
  computed: {
    corporation() {
      return this.$store.state.corporations.corporation
    },
    isAutoLogoutEnableFlag() {
      return this.$store.state.corporations.addCorporation.autoLogoutEnableFlag
    },
    passwordEnableFlag() {
      return this.$store.state.corporations.corporation.passwordEnableFlag
        ? 'ON'
        : 'OFF'
    },
    autoLogoutEnableFlag() {
      return this.$store.state.corporations.corporation.autoLogoutEnableFlag
        ? 'ON'
        : 'OFF'
    },
    ratingQuarityEnableFlag() {
      return this.$store.state.corporations.corporation.ratingQuarityEnableFlag
        ? 'ON'
        : 'OFF'
    },
    autoLogoutSecond() {
      return (
        parseInt(
          this.$store.state.corporations.corporation.autoLogoutSecond / 3600
        ) + '時間'
      )
    },
    callAppList() {
      let checkedCallAppList = []
      let usedCallAppList = []
      for (let i = 0; i < this.corporation.callAppList.length; i++) {
        if (this.corporation.callAppList[i].isActiveCallAppNotNull) {
          checkedCallAppList.push(this.corporation.callAppList[i].id)
        }
        if (this.corporation.callAppList[i].isUsed) {
          usedCallAppList.push(this.corporation.callAppList[i].id)
        }
      }
      let callAppList = this.$store.state.corporations.callAppDefine
      for (let i = 0; i < callAppList.length; i++) {
        callAppList[i].checked = checkedCallAppList.includes(callAppList[i].id)
        callAppList[i].isUsed = usedCallAppList.includes(callAppList[i].id)
      }
      return callAppList
    }
  },
  methods: {
    inputUpdate(e) {
      this.$store.dispatch('corporations/inputUpdate', {
        name: e,
        value: event.target.value
      })
    }
  }
}
</script>

<style scoped>
.corporation_bottom {
  top: 130px;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationComponents/tenantOptionEditInfo.vue